/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasXML } from '../../models/OasXML';

/**
 * Models an OpenAPI 3.0.x XML.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasXML
 */
export class Oas30XML extends OasXML {
    constructor() {
        super();
    }
}
Oas30XML["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30XML";
Oas30XML["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




